import React from 'react';
import { Source, Layer } from 'react-mapbox-gl';

export const MapLayer = ({
	layer,
	onFeatureClick,
	onFeatureMouseEnter,
	onFeatureMouseLeave,
	mapRef
}) => {
	const {
		id,
		data,
		type = 'circle',
		paint = {},
		layout = {},
		minZoom,
		maxZoom
	} = layer;

	const sourceId = `${id}-source`;

	return (
		<>
			<Source id={sourceId} geoJsonSource={data} />

			<Layer
				id={id}
				sourceId={sourceId}
				type={type}
				paint={paint}
				layout={layout}
				minZoom={minZoom}
				maxZoom={maxZoom}
				onClick={
					onFeatureClick
						? (e) => onFeatureClick(e.features?.[0], e, mapRef.current, layer)
						: undefined
				}
				onMouseEnter={
					//(e)=>console.log(e)
					onFeatureMouseEnter
						? (e) => onFeatureMouseEnter(e.features?.[0], e, mapRef.current, layer)
						: undefined
				}
				onMouseLeave={
					onFeatureMouseLeave
						? (e) => onFeatureMouseLeave(e.features?.[0], e, mapRef.current, layer)
						: undefined
				}
			/>
		</>
	);
};
